// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tU oJ","whiteTheme":"tV","markdownWrapper":"tW"};